"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDesktopAskpassTrampolinePath = getDesktopAskpassTrampolinePath;
exports.getDesktopAskpassTrampolineFilename = getDesktopAskpassTrampolineFilename;
exports.getDesktopCredentialHelperTrampolinePath = getDesktopCredentialHelperTrampolinePath;
exports.getDesktopCredentialHelperTrampolineFilename = getDesktopCredentialHelperTrampolineFilename;
exports.getSSHWrapperPath = getSSHWrapperPath;
exports.getSSHWrapperFilename = getSSHWrapperFilename;
const tslib_1 = require("tslib");
const Path = tslib_1.__importStar(require("path"));
function getDesktopAskpassTrampolinePath() {
    return Path.join(__dirname, 'build', 'Release', getDesktopAskpassTrampolineFilename());
}
function getDesktopAskpassTrampolineFilename() {
    return process.platform === 'win32'
        ? 'desktop-askpass-trampoline.exe'
        : 'desktop-askpass-trampoline';
}
function getDesktopCredentialHelperTrampolinePath() {
    return Path.join(__dirname, 'build', 'Release', getDesktopCredentialHelperTrampolineFilename());
}
function getDesktopCredentialHelperTrampolineFilename() {
    return process.platform === 'win32'
        ? 'desktop-credential-helper-trampoline.exe'
        : 'desktop-credential-helper-trampoline';
}
function getSSHWrapperPath() {
    return Path.join(__dirname, 'build', 'Release', getSSHWrapperFilename());
}
function getSSHWrapperFilename() {
    return process.platform === 'win32' ? 'ssh-wrapper.exe' : 'ssh-wrapper';
}
//# sourceMappingURL=index.js.map